module.exports = __webpack_public_path__ + "img/202603_02.76956c51.png";